import React, { useState } from 'react'
import _get from 'lodash/get'
import CustomToggle from '../_library/CustomToggle'

const EntryRules = ({ rules, onChange, errors = {}, prefix = 'eventRules' }) => {
  const ticket_scan_rules = _get(rules, 'ticket_scan_rules', [])
  const [scanningBehavior, setScanningBehavior] = useState(
    ticket_scan_rules.length > 0 ? 'multiple_per_event' : 'once_per_event',
  )

  const handlePrimaryBehaviorChange = (fieldKey, checked) => {
    const behavior = checked ? 'multiple_per_event' : 'once_per_event'
    const newRules = {
      ticket_scan_rules: behavior === 'multiple_per_event' ? [{ day: 1 }] : [],
    }
    onChange(newRules)
    setScanningBehavior(behavior)
  }

  const handleAddScanRule = () => {
    const newRule = { day: 1 }
    const newTimeRules = [...ticket_scan_rules, newRule]

    const newRules = {
      ticket_scan_rules: newTimeRules,
    }
    onChange(newRules)
  }

  const handleRemoveScanRule = index => {
    const newTimeRules = ticket_scan_rules.filter((_, i) => i !== index)

    const newRules = {
      ticket_scan_rules: newTimeRules,
    }
    onChange(newRules)
  }

  const handleScanRuleChange = (index, period, value) => {
    // Allow empty string for editing, only parse when there's a value
    const quantity = value === '' ? '' : parseInt(value, 10)

    const updatedRule = { [period]: quantity }
    const newTimeRules = [...ticket_scan_rules]
    newTimeRules[index] = updatedRule

    const newRules = {
      ticket_scan_rules: newTimeRules,
    }
    onChange(newRules)
  }

  const getRulePeriod = rule => {
    return Object.keys(rule)[0]
  }

  const getRuleQuantity = rule => {
    return Object.values(rule)[0]
  }

  return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        {/* Primary Behavior Selection */}
        <div className="row">
          <div className="col-sm-12">
            <CustomToggle
              id="scanning-behavior"
              onText="Tickets can be scanned multiple times per event"
              value={scanningBehavior === 'multiple_per_event'}
              checked={scanningBehavior === 'multiple_per_event'}
              onChange={handlePrimaryBehaviorChange}
            />
          </div>
        </div>

        {/* Time Period Rules - only show if multiple_per_event is selected or rules exist */}
        {(scanningBehavior === 'multiple_per_event' || ticket_scan_rules.length > 0) && (
          <>
            {ticket_scan_rules.map((rule, index) => {
              const period = getRulePeriod(rule)
              const quantity = getRuleQuantity(rule)
              const errorPath = `${prefix}.ticket_scan_rules[${index}].quantity`
              const quantityError = _get(errors, errorPath)
              return (
                <div key={index} className="row">
                  <div className="col-sm-4">
                    <div className="floating-field-group active">
                      <div className="floating-field">
                        <label className="control-label" htmlFor={`rule-${index}-period`}>
                          Time Period
                        </label>
                        <select
                          id={`rule-${index}-period`}
                          className="form-control"
                          value={period}
                          onChange={e => {
                            const newRule = { [e.target.value]: quantity }
                            const newScanRules = [...ticket_scan_rules]
                            newScanRules[index] = newRule

                            const newRules = {
                              ticket_scan_rules: newScanRules,
                            }
                            onChange(newRules)
                          }}
                        >
                          <option value="day">Day</option>
                          <option value="hour">Hour</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className={`form-group ${quantityError ? 'has-error' : ''}`}>
                      <div className="floating-field-group active">
                        <div className="floating-field">
                          <label className="control-label" htmlFor={`rule-${index}-quantity`}>
                            Max Scans
                          </label>
                          <input
                            id={`rule-${index}-quantity`}
                            type="number"
                            className="form-control"
                            min="1"
                            value={quantity}
                            onChange={e => handleScanRuleChange(index, period, e.target.value)}
                          />
                        </div>
                      </div>
                      {quantityError && <div className="help-block">{quantityError}</div>}
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="hold_buttons_block" style={{ marginTop: '12px' }}>
                      {ticket_scan_rules.length > 1 && (
                        <div
                          className="hold_trash_icon"
                          style={{
                            marginRight: '12px',
                          }}
                        >
                          <i
                            aria-hidden
                            onClick={() => handleRemoveScanRule(index)}
                            style={{ fontSize: '22px', cursor: 'pointer' }}
                            className="fa fa-trash"
                          />
                        </div>
                      )}
                      {index === ticket_scan_rules.length - 1 && (
                        <div className="hold_trash_icon">
                          <i
                            aria-hidden
                            className="fa fa-fw fa-plus"
                            onClick={handleAddScanRule}
                            style={{ fontSize: '22px', cursor: 'pointer' }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </>
        )}
      </div>
  )
}

export default EntryRules
